import { trackUserEvent } from './ubeTracker';
export var PerformanceEntryType;
(function (PerformanceEntryType) {
    PerformanceEntryType["Mark"] = "mark";
    PerformanceEntryType["Measure"] = "measure";
    PerformanceEntryType["Resource"] = "resource";
    PerformanceEntryType["Paint"] = "paint";
})(PerformanceEntryType || (PerformanceEntryType = {}));
var MarkPrefix;
(function (MarkPrefix) {
    MarkPrefix["Start"] = "start";
    MarkPrefix["End"] = "end";
})(MarkPrefix || (MarkPrefix = {}));
export function isPerformanceSupported() {
    return Boolean(window.performance &&
        window.performance.mark !== undefined &&
        window.performance.measure !== undefined &&
        window.performance.getEntries !== undefined);
}
export function startPerformanceMeasure(name) {
    return addPerformanceMark(`${MarkPrefix.Start}-${name}`);
}
export function stopPerformanceMeasure(name, trackingData) {
    const startName = `${MarkPrefix.Start}-${name}`;
    const endName = `${MarkPrefix.End}-${name}`;
    const mark = addPerformanceMark(endName);
    if (!mark) {
        return null;
    }
    const measure = measurePerformance(name, startName, endName);
    clearPerformanceEntriesByName([name, startName, endName]);
    // If a starting or ending mark is not found, a measure will not be created.
    if (!measure) {
        return null;
    }
    if (trackingData) {
        if (!trackingData.eventName) {
            trackingData.eventName = `Performance Measure for ${measure.name}`;
        }
        const { eventName, moduleName, metadata, options } = trackingData;
        trackUserEvent(moduleName, eventName, Object.assign(Object.assign({}, metadata), { measure }), options);
    }
    return measure;
}
export function addPerformanceMark(name) {
    if (!isPerformanceSupported()) {
        return null;
    }
    window.performance.mark(name);
    return findPerformanceEntry(name, PerformanceEntryType.Mark);
}
export function findPerformanceEntry(name, type) {
    const entries = window.performance.getEntriesByName(name) || [];
    if (entries.length) {
        // There could be multiple entries for the same name, so get the latest
        const entry = entries[entries.length - 1];
        if (entry.entryType === type) {
            return entry;
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
}
export function measurePerformance(name, startName, endName) {
    if (!isPerformanceSupported()) {
        return null;
    }
    const hasStartMark = Boolean(findPerformanceEntry(startName, PerformanceEntryType.Mark));
    const hasEndMark = Boolean(findPerformanceEntry(endName, PerformanceEntryType.Mark));
    if (!hasStartMark || !hasEndMark) {
        return null;
    }
    window.performance.measure(name, startName, endName);
    return findPerformanceEntry(name, PerformanceEntryType.Measure);
}
export function clearPerformanceEntriesByName(namesToClear) {
    if (!isPerformanceSupported()) {
        return;
    }
    const names = Array.isArray(namesToClear) ? namesToClear : [namesToClear];
    names.forEach(name => {
        window.performance.clearMarks(name);
        window.performance.clearMeasures(name);
    });
}
